// Auto-generated during build process
export const APP_VERSION = '20261024.01-0eb1dbd';